import type { UserItem } from '@/types/userItem';
import type { SinglesCondition, SealedCondition } from '@/types/listing';

const VALID_SINGLES: SinglesCondition[] = [
  'mint', 'near_mint', 'lightly_played', 'moderately_played', 'heavily_played', 'damaged',
];

const VALID_SEALED: SealedCondition[] = [
  'factory_sealed', 'factory_sealed_minor', 'factory_sealed_major', 'resealed', 'opened',
];

export function getSinglesCondition(item: UserItem): SinglesCondition | undefined {
  if (item.category !== 'singles') return undefined;
  const cond = item.condition as string;
  if (VALID_SINGLES.includes(cond as SinglesCondition)) return cond as SinglesCondition;
  return 'mint';
}

export function getSealedCondition(item: UserItem): SealedCondition | undefined {
  if (item.category !== 'sealed') return undefined;
  const cond = (item.sealed_condition || item.condition) as string;
  if (VALID_SEALED.includes(cond as SealedCondition)) return cond as SealedCondition;
  // Legacy 'sealed' maps to 'factory_sealed'
  if (cond === 'sealed') return 'factory_sealed';
  return 'factory_sealed';
}

/** Normalize legacy language codes from imports to match form constants. */
export function normalizeLanguage(lang: string | null | undefined): string {
  if (!lang) return 'english';
  const mapping: Record<string, string> = {
    's-chinese': 'chinese_simplified',
    't-chinese': 'chinese_traditional',
  };
  return mapping[lang] || lang;
}
